import store from "../store/store";
import { WsApi } from "@/utils/http-client";

export default class Term {
  constructor(data) {
    this.detailsEndpoint = data.detailsEndpoint;
    this.name = data.name;
    this.id = parseInt(data.termsAndConditionsId);
    this.accepted = false;
    this.update(data);
  }
  update(data) {
    this.content = data.Content || data.content;
    this.description = data.Description || data.description;
    this.isSignatureRequired = data.IsSignatureRequired || data.isSignatureRequired;
    this.type = data.Type || data.type;
  }
  get endpoint() {
    return (
      this.detailsEndpoint ||
      WsApi.getUrl("/PaymentServices/TermsAndDisclaimers/Details", { termsAndConditionsId: this.id })
    );
  }
  get isLoaded() {
    return !!this.description;
  }
  getFormattedContent() {
    const replacingElements = {
      PayerName: `${store.state.payer.firstName} ${store.state.payer.lastName}`,
      PayerCompanyName: store.state.payer.company,
      SurchargeLabel: store.state.merchant.paymentTypes.creditCards.surchargeLabel,
    };
    let formattedContent = this.content || "";
    Object.keys(replacingElements).forEach((replacementText) => {
      const findingRegex = new RegExp(`{{${replacementText}}}`, "g");
      formattedContent = formattedContent.replace(findingRegex, replacingElements[replacementText]);
    });
    return formattedContent;
  }
  getPayload() {
    const payload = {
      Type: this.type,
      TermsAndConditionsId: this.id,
    };
    if (this.isSignatureRequired) {
      payload.Signature = store.state.termsAndConditions.signature;
      payload.Position = store.state.termsAndConditions.acceptedByPosition;
      payload.AcceptedBy = store.state.termsAndConditions.acceptedBy;
    }
    return payload;
  }
}
